// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"a0095b69","71":"d44b79e0","458":"b987316a","540":"4d17569b","893":"2e2a0690","991":"d29a8bc3","994":"d72efde0"}[chunkId] + ".css";
};